<template>
  <div class="py-4 container-fluid">
    <a class="btn btn-sm btn-success" style="margin-right: 10px;" :href="apiUrl+'export-excel/vendor-list?vendor_code='+search.vendor_code+'&company_name='+search.company_name+'&contact_person='+search.contact_person+'&address='+search.address+'&email='+search.email+'&vendor_category='+search.vendor_category+'&item_group='+search.item_group+'&status='+search.status+''" target="_BLANK"><i class="fa fa-file-excel-o"></i> Export to Excel</a>
    <a class="btn btn-sm btn-primary" style="margin-right: 10px;" :href="apiUrl+'print-pdf/vendor-list?vendor_code='+search.vendor_code+'&company_name='+search.company_name+'&contact_person='+search.contact_person+'&address='+search.address+'&email='+search.email+'&vendor_category='+search.vendor_category+'&item_group='+search.item_group+'&status='+search.status+''" target="_BLANK"><i class="fa fa-file-pdf-o"></i> Export to PDF</a>
    <div class=" row">
      <div class="col-12">
          <div class="card"> 
            <div class="row">
              <div class="col-lg-4">
                <div class="card-header pb-0">
                  <h6>Vendor Management</h6>
                </div>
              </div>
              <div class="col-lg-4">
                <input type="text" class="form-control mt-3" placeholder="Search by Vendor Name" v-model="search.company_name" @keyup="get()">
              </div>
              <div class="col-lg-4 float-right">
                <argon-button
                  style="margin-right: 10px; margin-left: 60px;"
                  class="mt-4"
                  variant="gradient"
                  color="secondary"
                  size="sm"
                  @click="filter()"
                ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="success"
                  size="sm"
                  @click="create()"
                ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add New</argon-button>
              </div>
            </div>
            
            <div class="card-body px-0 pt-0 pb-2 mt-4">
              <div class="table-responsive p-0 scroll">
                <table class="table table-hover table-striped align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">No</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">VENDOR CODE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">VENDOR NAME</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PIC</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">NPWP</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ADDRESS</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">EMAIL</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">NO HP</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PHONE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">FAX</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">CATEGORY</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ITEM GROUP</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">STATUS</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">VENDOR REVIEW</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in table.data" :key="i">
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ i + 1 }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.vendor_code }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.company_name }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.contact_person }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.npwp }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.address }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.email }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.no_hp }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.phone }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.fax }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.vendor_category }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.item_group }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="badge badge-sm bg-gradient-success" v-if="row.status == 'Active'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-dark" v-if="row.status == 'Blacklist'">{{ row.status }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.note }} </span>
                      </td>
                      <td class="align-middle text-center">
                        <i class="fa fa-history fa-sm" aria-hidden="true" title="Riwayat pembelian dari vendor ini" style="cursor: pointer; margin-right: 20px;" @click="purchaseHistory(row.vendor_code)"></i>
                        <i class="fas fa-edit fa-sm" aria-hidden="true" title="Edit data vendor ini" style="cursor: pointer; margin-right: 20px;" @click="edit(row.id)"></i>
                        <i class="fa fa-trash fa-sm" aria-hidden="true" title="Hapus vendor ini" style="cursor: pointer; margin-right: 20px;" @click="remove(row.id)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <div class="float-right">
                <!-- <span class="font-weight-bold text-danger ">TOTAL WORKING HOUR : {{ totalWorkingHour }} Hour {{ totalWorkingMinutes }} Minutes</span> -->
              </div>
              <div class="float-right">
                <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL ADD DATA ======= -->
  <div class="container">
    <vue-final-modal v-model="form.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{form.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="form.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Company Name <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Company Name" v-model="vendorData.company_name">
        <label for="example-text-input" class="form-control-label mt-3">NPWP <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="NPWP" v-model="vendorData.npwp">
        <label for="example-text-input" class="form-control-label mt-3">Contact Person <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Contact Person" v-model="vendorData.contact_person">
        <label for="example-text-input" class="form-control-label mt-3">Address <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Address" v-model="vendorData.address">
        <label for="example-text-input" class="form-control-label mt-3">Email <span style="color: red;">*</span></label>
        <input type="email" class="form-control" placeholder="Email" v-model="vendorData.email">
        <label for="example-text-input" class="form-control-label mt-3">No HP </label>
        <input type="text" class="form-control" placeholder="No HP" v-model="vendorData.no_hp">
        <label for="example-text-input" class="form-control-label mt-3">Phone </label>
        <input type="text" class="form-control" placeholder="Phone" v-model="vendorData.phone">
        <label for="example-text-input" class="form-control-label mt-3">Fax </label>
        <input type="text" class="form-control" placeholder="Fax" v-model="vendorData.fax">
        <label for="example-text-input" class="form-control-label mt-3">Vendor Category <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="vendorData.vendor_category">
          <option value="Agent">Agent</option>
          <option value="Consumable">Consumable</option>
          <option value="Equipment">Equipment</option>
          <option value="Manufacture">Manufacture</option>
          <option value="Mill Maker">Mill Maker</option>
          <option value="Services">Services</option>
          <option value="Supplier">Supplier</option>
          <option value="Tools">Tools</option>
          <option value="Trading Company">Trading Company</option>
          <option value="Transport">Transport</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Item Group <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Item Group" v-model="vendorData.item_group">
        <label for="example-text-input" class="form-control-label mt-3">Vendor Review </label>
        <textarea class="form-control" v-model="vendorData.note" placeholder="Vendor Review"></textarea>
        <label for="example-text-input" class="form-control-label mt-3">Vendor Status <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="vendorData.status">
          <option value="Active">Active</option>
          <option value="Blacklist">Blacklist</option>
        </select>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-4"> 
        </div>
        <div class="col-3" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="form.show = true">Close</argon-button>
        </div>
        <div class="col-2">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="save()">Save</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
  </div>

  <!-- =======  MODAL FILTER ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilter.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Vendor Code </label>
        <input type="text" class="form-control" placeholder="Vendor Code" v-model="search.vendor_code" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Company Name </label>
        <input type="text" class="form-control" placeholder="Company Name" v-model="search.company_name" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Contact Person </label>
        <input type="text" class="form-control" placeholder="Contact Person" v-model="search.contact_person" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Address </label>
        <input type="text" class="form-control" placeholder="Address" v-model="search.address" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Email </label>
        <input type="email" class="form-control" placeholder="Email" v-model="search.email" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Vendor Category </label>
        <select class="form-select" aria-label="Default select example" v-model="search.vendor_category" v-on:keyup.enter="get()">
          <option value="Agent">Agent</option>
          <option value="Consumable">Consumable</option>
          <option value="Equipment">Equipment</option>
          <option value="Manufacture">Manufacture</option>
          <option value="Mill Maker">Mill Maker</option>
          <option value="Services">Services</option>
          <option value="Supplier">Supplier</option>
          <option value="Tools">Tools</option>
          <option value="Trading Company">Trading Company</option>
          <option value="Transport">Transport</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Vendor Status </label>
        <select class="form-select" aria-label="Default select example" v-model="search.status" v-on:keyup.enter="get()">
          <option value="Active">Active</option>
          <option value="Blacklist">Blacklist</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Item Group </label>
        <input type="text" class="form-control" placeholder="Item Group" v-model="search.item_group" v-on:keyup.enter="get()">

        <!-- <label for="example-text-input" class="form-control-label mt-3">Date Range</label>
        <flat-pickr :config="{ mode: 'range',}" class="form-control" v-model="search.date"/> -->
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-4"> 
        </div>
        <div class="col-3" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="search = {}">Clear</argon-button>
        </div>
        <div class="col-2">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="get()">Filter</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- ======= PURCHASE HISTORY ======= -->
  <div class="container">
    <vue-final-modal v-model="formPurchaseHistory.show" classes="modal-container" content-class="modal-content-width" :z-index="10000" :focus-retain="false">
      <!-- header -->
      <div class="row">
        <div class="col-11 text-center">
          <span class="modal__title">{{formPurchaseHistory.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formPurchaseHistory.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <div class="row" v-if="tablePurcHistory.data[0]">
          <div class="col-6">
            <span class="mt-2">VENDOR CODE &nbsp;&nbsp;:&nbsp; {{ tablePurcHistory.data[0].vendor_code }}</span><br>
            <span class="mt-2">VENDOR NAME &nbsp;&nbsp;:&nbsp; {{ tablePurcHistory.data[0].company_name }}</span><br>
            <span class="mt-2">PIC &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; {{ tablePurcHistory.data[0].contact_person }}</span><br>
            <span class="mt-2">NPWP &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; {{ tablePurcHistory.data[0].npwp }}</span><br>
            <span class="mt-2">EMAIL &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; {{ tablePurcHistory.data[0].email }}</span><br>
            <span class="mt-2">NO. HP &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; {{ tablePurcHistory.data[0].no_hp }}</span><br>
          </div>
          <div class="col-6">
            <span class="mt-2">PHONE &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; {{ tablePurcHistory.data[0].phone }}</span><br>
            <span class="mt-2">FAX &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; {{ tablePurcHistory.data[0].fax }}</span><br>
            <span class="mt-2">CATEGORY &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; {{ tablePurcHistory.data[0].vendor_category }}</span><br>
            <span class="mt-2">ITEM GROUP &nbsp;&nbsp;:&nbsp; {{ tablePurcHistory.data[0].item_group }}</span><br>
            <span class="mt-2">STATUS &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;
              <span class="badge badge-sm bg-gradient-success" v-if="tablePurcHistory.data[0].status == 'Active'">{{ tablePurcHistory.data[0].status }} </span>
              <span class="badge badge-sm bg-gradient-dark" v-if="tablePurcHistory.data[0].status == 'Blacklist'">{{ tablePurcHistory.data[0].status }} </span>
            </span><br>
          </div>
          <span class="mt-2">ADDRESS &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; {{ tablePurcHistory.data[0].address }}</span><br>
        </div> <hr>

        <div class="table-responsive p-0 scroll">
          <table class="table table-bordered table-hover table-striped align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">No</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PO NO.</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">DATE</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PIC</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PART NAME</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Specification</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Size</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Unit</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Qty</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Unit Price</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Amount</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Discount</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">VAT</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Del Condition</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Del Time</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Payment Terms</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">RFQ NO.</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tablePurcHistory.data" :key="i">
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">{{ i + 1 }}. </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.po_no }} </span>
                </td>
                <td class="align-middle text-left text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ moment(row.issue_date).locale('id').format('LL') }} </span>
                </td>
                <td class="align-middle text-left text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.created_by }} </span>
                </td>
                <td class="align-middle text-left text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.part_name }} </span>
                </td>
                <td class="align-middle text-left text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.specification }} </span>
                </td>
                <td class="align-middle text-left text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.size }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.unit }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.qty }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.unit_price }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.amount }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.discount }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.price }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.del_condition }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.del_time }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.payment_terms }} </span>
                </td>
                <td class="align-middle text-left text-sm">
                  <span class="text-secondary text-xs font-weight-bold">  {{ row.rfq_code }} </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

</template>

<script>

import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import Api from '@/helpers/api';
import config from '@/configs/config';
import { toast } from 'vue3-toastify';
// import Multiselect from 'vue-multiselect'
import 'vue3-toastify/dist/index.css';
// import flatPickr from 'vue-flatpickr-component';
// import 'flatpickr/dist/flatpickr.css';
import BasePagination from "@/components/BasePagination";
var moment = require('moment');
import vendorList from '@/services/procurement/vendorList.service';


export default {
  name: "tables",
  components: {
    ArgonButton,
    VueFinalModal,
    // Multiselect,
    // flatPickr,
    BasePagination
  },
  data() {
    return {
      pagination: {
        page_count: '',
        page: 1,
      },
      moment:moment,
      table: {
        data: []
      },
      tablePurcHistory: {
        data: []
      },
      tableActivity: {
        data: []
      },
      tableGroup: {
        data: []
      },
      tableEmployee: {
        data: []
      },
      form: {
        add: true,
        title: "Add Data",
        show: false
      },
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      formPurchaseHistory: {
        add: true,
        title: "PURCHASE HISTORY",
        show: false
      },
      dataImport: '',
      onLoading: false,
      tabelError: {
        data: []
      },
      storageUrl : config.storageUrl,
      vendorData: {},
      search: {
        vendor_code: '',
        company_name: '',
        contact_person: '',
        address: '',
        email: '',
        vendor_category: '',
        item_group: '',
        status: '',
      },
      searchMenu: '',
      apiUrl :config.apiUrl,
      totalWorkingHour: '',
      totalWorkingMinutes: '',

    };
  },
  mounted(){
    this.get();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
  },
  methods: {
    nameWithLang ({ project_number, project_name }) {
      return `${project_number} | ${project_name}`
    },
    get(param){
      let context = this;               
      Api(context, vendorList.index({vendor_code: this.search.vendor_code, company_name: this.search.company_name, contact_person: this.search.contact_person, address: this.search.address, email: this.search.email, vendor_category: this.search.vendor_category, item_group: this.search.item_group, status: this.search.status, page: context.pagination.page})).onSuccess(function(response) {    
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page

          // context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.formFilter.show  = false;
      })
      .call()
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading        = false;
      this.pagination.page  = 1 ;
    },
    create() {
      this.form.add   = true;
      this.form.show  = true;
      this.form.title = "Add Data";
      this.vendorData = {};
    },
    edit(id) {
      let context = this;               
      Api(context, vendorList.show(id)).onSuccess(function(response) {
          context.vendorData = response.data.data;
          context.form.show  = true;
          context.form.title = 'Edit Data';   
      })
      .call()        
    },
    save(){
      let api      = null;
      let context  = this;
      let formData = new FormData();

      if (context.vendorData.company_name != undefined && context.vendorData.npwp != undefined && context.vendorData.contact_person != undefined && context.vendorData.address != undefined && context.vendorData.email != undefined && context.vendorData.vendor_category != undefined && context.vendorData.item_group != undefined) {
        formData.append('company_name', context.vendorData.company_name);
        formData.append('npwp', context.vendorData.npwp);
        formData.append('contact_person', context.vendorData.contact_person);
        formData.append('address', context.vendorData.address);
        formData.append('email', context.vendorData.email);
        formData.append('no_hp', (context.vendorData.no_hp == undefined) ? '-' : context.vendorData.no_hp);
        formData.append('phone', (context.vendorData.phone == undefined) ? '-' : context.vendorData.phone);
        formData.append('fax', (context.vendorData.fax == undefined) ? '-' : context.vendorData.fax);
        formData.append('vendor_category', context.vendorData.vendor_category);
        formData.append('item_group', context.vendorData.item_group);
        formData.append('note', (context.vendorData.note == undefined) ? '-' : context.vendorData.note);
        formData.append('status', context.vendorData.status);
      }else{
        return alert('The Red Star Field is Mandatory')
      }

      if (context.form.title == 'Add Data') {
          api = Api(context, vendorList.create(formData));
      } else {
          api = Api(context, vendorList.update(this.vendorData.id, formData));
      }
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.get();
        context.form.show = false;
        context.notify((context.form === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) { 
        context.notify((context.form != 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
      })
      .call();
    },
    remove(id) {
      var r = confirm("Are you sure you want to delete this data ?");
      if (r == true) {
        let context = this;
        Api(context, vendorList.delete(id)).onSuccess(function(response) {
            context.get();
            context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    purchaseHistory(vendorCode) {
      let context = this;               
      Api(context, vendorList.purHistory(vendorCode)).onSuccess(function(response) {
          context.tablePurcHistory.data = response.data.data;
          context.formPurchaseHistory.show  = true;
      })
      .call()        
    },
    filesChange(e) {
        this.vendorData.attachment = e.target.files[0];
    },
    changePage(page){
      this.pagination.page = page;
      this.get();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }
    },

  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
/*MODAL WIDTH KUSUS LEBAR BESAR*/
::v-deep .modal-content-width {
  /*display: flex;*/
  /*flex-direction: column;*/
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 1090px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll-model { 
  overflow: auto;  
}
.scroll-model thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}
.scroll { 
  overflow: auto; 
  height: 500px; 
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}
</style>
